import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  giveFeedback: {
    id: 'pipelines.components.feedbackCollector.giveFeedbackTitle',
    description: 'Title of the pipelines product feedback modal',
    defaultMessage: 'Give feedback',
  },
  giveFeedbackPlaceholder: {
    id: 'pipelines.components.feedbackCollector.giveFeedbackPlaceholder',
    description:
      'Placeholder text in the pipelines product feedback summary field',
    defaultMessage: "Let us know what's on your mind",
  },
  giveFeedbackTitleDetailsOne: {
    id: 'pipelines.components.feedbackCollector.giveFeedbackTitleDetailsOne',
    description: 'First paragraph under the pipelines feedback modal title',
    defaultMessage: 'Your thoughts help us improve Atlassian products',
  },
  giveFeedbackTitleDetailsTwo: {
    id: 'pipelines.components.feedbackCollector.giveFeedbackTitleDetailsTwo',
    description:
      'Second paragraph under the pipelines feedback modal title. The "support site" link text is wrapped in <link> tags.',
    defaultMessage:
      "If you''re looking to get help or want to report a bug, visit our <link>support site.</link>",
  },
  canContactLabel: {
    id: 'pipelines.components.feedbackCollector.canContactLabel',
    description:
      'Label for the contact permission checkbox in feedback modal. The "privacy policy" link text is wrapped in <link> tags.',
    defaultMessage:
      'Atlassian can contact me about this feedback. See our <link>privacy policy</link>',
  },
  enrollLabel: {
    id: 'pipelines.components.feedbackCollector.enrollLabel',
    description:
      'Label for the research enrollment checkbox in feedback modal. The "Atlassian Research Group" link text is wrapped in <link> tags.',
    defaultMessage:
      "I''d like to help improve Atlassian products by joining the <link>Atlassian Research Group</link>",
  },
});
